import React from 'react';

const sections = [
  {
    title: '1. Какие данные мы собираем',
    text: 'Мы собираем данные, которые вы предоставляете при регистрации: имя пользователя, адрес электронной почты. При совершении покупок сохраняется история заказов. Мы не собираем платёжные данные — они обрабатываются платёжными системами напрямую.',
  },
  {
    title: '2. Как мы используем данные',
    text: 'Данные используются для идентификации пользователя, доставки цифровых товаров, работы личного кабинета и улучшения качества сервиса. Мы не передаём личные данные третьим лицам без вашего согласия.',
  },
  {
    title: '3. Файлы cookie',
    text: 'Сайт использует cookie-файлы для корректной работы авторизации и сохранения настроек. Вы можете отключить cookie в настройках браузера, однако это может повлиять на работу сайта.',
  },
  {
    title: '4. Хранение данных',
    text: 'Данные хранятся на защищённых серверах. Мы принимаем технические и организационные меры для защиты от несанкционированного доступа, изменения или удаления данных.',
  },
  {
    title: '5. Ваши права',
    text: 'Вы вправе запросить удаление или изменение своих персональных данных. Для этого обратитесь в поддержку по адресу support@freeapp.ru. Мы обработаем запрос в течение 10 рабочих дней.',
  },
  {
    title: '6. Изменение политики',
    text: 'Мы можем обновлять данную политику. О существенных изменениях уведомим по электронной почте или через уведомление на сайте. Актуальная версия всегда доступна на этой странице.',
  },
];

const PrivacyPage = () => (
  <div className="min-h-screen overflow-x-hidden bg-background px-4 py-6 text-foreground sm:py-8">
    <div className="mx-auto max-w-3xl">

      <div className="mb-8">
        <h1 className="text-3xl font-semibold sm:text-5xl">Политика конфиденциальности</h1>
        <p className="mt-3 text-sm text-foreground/35">Последнее обновление: май 2025</p>
      </div>

      <div className="rounded-[28px] border border-foreground/10 bg-card divide-y divide-foreground/[0.07] shadow-[0_24px_70px_rgba(0,0,0,0.35)]">
        {sections.map(({ title, text }) => (
          <div key={title} className="px-6 py-5">
            <p className="mb-2 font-semibold text-foreground">{title}</p>
            <p className="text-sm leading-6 text-foreground/55">{text}</p>
          </div>
        ))}
      </div>

    </div>
  </div>
);

export default PrivacyPage;
